<template>
	<div>
		<el-form :inline="true">
			<el-form-item>
				<el-input
						v-model="searchForm.name"
						placeholder="姓名"
						clearable
						style="width: 200px"
				>
				</el-input>
				&nbsp;&nbsp;&nbsp;&nbsp;
				<el-input
						v-model="searchForm.phone"
						placeholder="手机号"
						clearable
						style="width: 200px"
				>
				</el-input>
			</el-form-item>

			<el-form-item>
				<el-button @click="getUserContactList">搜索</el-button>
			</el-form-item>
		</el-form>

		<el-table
				ref="multipleTable"
				:data="tableData"
				tooltip-effect="dark"
				style="width: 100%"
				border
				stripe>
			<el-table-column
					prop="name"
					label="姓名"
					width="80">
			</el-table-column>
			<el-table-column
					prop="surname"
					label="姓氏"
					width="60">
			</el-table-column>
			<el-table-column
					prop="mail"
					label="邮箱地址"
					width="170">
			</el-table-column>
			<el-table-column
					prop="phone"
					label="电话号码"
					width="130">
			</el-table-column>
			<el-table-column
					prop="topic"
					label="标题"
					width="120"
					:show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column
					prop="message"
					label="消息内容"
					width="150"
					:show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column
					prop="isContact"
					label="是否联系"
					width="80">
				<template slot-scope="scope">
					<el-tag size="small" v-if="scope.row.isContact === true" type="success">已联系</el-tag>
					<el-tag size="small" v-else-if="scope.row.isContact === false" type="danger">未联系</el-tag>
				</template>
			</el-table-column>
			<el-table-column
					prop="createTime"
					width="160"
					label="创建时间"
			>
			</el-table-column>
			<el-table-column
					prop="icon"
					label="操作">

				<template slot-scope="scope">
					<el-button type="text" @click="editHandle(scope.row.id)">设为已联系</el-button>
				</template>
			</el-table-column>
		</el-table>

		<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				layout="total, sizes, prev, pager, next, jumper"
				:page-sizes="[10, 20, 50, 100]"
				:current-page="page.current"
				:page-size="page.size"
				:total="page.total">
		</el-pagination>
	</div>
</template>

<script>
	export default {
		name: "UserContact",
		data() {
			return {
				searchForm: {},
				page: {
					total: 0,
					size: 10,
					current: 1,
				},
				tableData: []
			}
		},
		created() {
			this.getUserContactList(this.page)
		},
		methods: {
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.page.size = val
				this.getUserContactList(this.page)
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.page.current = val
				this.getUserContactList(this.page)
			},
			getUserContactList(page) {
				this.$axios.post("/uxm/user-contact/page", {
					name: this.searchForm.name,
					phone: this.searchForm.phone,
					current: page == null ? this.page.current : page.current,
					size: page == null ? this.page.size : page.size,
				}).then(res => {
					this.tableData = res.data.data.records
					this.page.size = res.data.data.size
					this.page.current = res.data.data.current
					this.page.total = res.data.data.total
				})
			},
			editHandle(id){
				this.$axios.post('/uxm/user-contact/updateState/'+ id).then(res => {
					this.$message({
						showClose: true,
						message: '恭喜你，操作成功',
						type: 'success',
						onClose: () => {
							this.getUserContactList()
						}
					});
				})
			}
		}
	}
</script>

<style scoped>

	.el-pagination {
		float: right;
		margin-top: 22px;
	}

</style>
